<template>
  <div
    ref="popup"
    role="dialog"
    aria-modal="true"
    :aria-labelledby="showTitle ? 'rfp-rr-show-full-review-title' : undefined"
    tabindex="-1"
    class="rfp-rr-show-full-review-157-or full-review-popup mobile-view-alignment"
    style="display: block"
  >
    <div
      role="button"
      :aria-label="modalCloseButtonAccessibleLabel"
      tabindex="0"
      class="rfp-rr-show-full-review-158-or review-popup-close"
      @keydown.space.prevent
      @keyup.space="closePopup"
      @keydown.enter="closePopup"
      @click="closePopup"
    >
      X
    </div>
    <h3
      v-if="showTitle"
      id="rfp-rr-show-full-review-title"
      class="rfp-rr-show-full-review-159-or rr-sub-title black clear"
    >
      {{ headerTitle }}
    </h3>

    <rfp-ratings-product-star
      v-for="(product, key) of popupFields"
      :key="key"
      :label-name="product.label"
      :label-value="product.value"
      :product-rating="product.rating"
      :is-star-rating="product.isStar"
      class="rfp-rr-show-full-review-160-or float-left"
      :class="{
        'rfp-rr-rating-rtl-float-right': isRightToLeftActive,
        'rr-avg-rating-content rfp-full-review-star-category': product.isStar,
        'rfp-full-review-sub-category': !product.isStar,
      }"
    />

    <p class="rfp-rr-show-full-review-165-or clear">{{ summary }}</p>
    <div class="rfp-rr-show-full-review-166-or rr-recomment-product clear">
      <div class="rfp-rr-show-full-review-167-or rr-sample-section float-left">
        <p style="margin-right: 0">
          <img
            :src="recommendListIcons"
            class="rfp-rr-show-full-review-168-or image-setup-for-list"
            :alt="recommendIconAltTexts"
          />
        </p>
        <p>
          {{ isRecommends }}
        </p>
      </div>
    </div>
    <div class="rfp-rr-show-full-review-169-or rr-comment-img-section clear float-left">
      <div class="rfp-rr-show-full-review-170-or review-gallery"></div>
    </div>
    <rfp-ratings-helpful
      :reported-text="reportedTexts"
      :report-text="reportTexts"
      :helpful-label="helpfulLabels"
      :rrid="rrids"
      :report-display="0"
      :update-helpful-review-api="updateHelpfulReviewApis"
      :update-not-helpful-review-api="updateNotHelpfulReviewApis"
      :report-review-api="reportReviewApis"
      :helpful-icon="helpfulIcon"
      :helpful-icon-alt="helpfulIconAlt"
      :non-helpful-icon="nonHelpfulIcon"
      :non-helpful-icon-alt="nonHelpfulIconAlt"
      :product-namess="productNames"
      :review-contentss="reviewContents"
      :review-titless="reviewTitles"
      :facebook-captionss="facebookCaptions"
      :facebook-share-enabled="facebookShareEnableds"
      :share-display-config="shareDisplayConfigs"
      :facebook-icon="facebookIcons"
      :facebook-icon-alt="facebookIconAlts"
      :facebook-tool-tips="facebookToolTips"
    ></rfp-ratings-helpful>
  </div>
</template>

<script>
import RfpRatingsHelpful from '../rfp-ratings-helpful/rfp-ratings-helpful.vue';
import RfpRatingsProductStar from '../rfp-ratings-product-star/rfp-ratings-product-star.vue';
import { trapFocus } from '../../../../../shared/utils/dom/focus';

export default {
  name: 'rfp-ratings-show-full-review',
  components: {
    RfpRatingsHelpful,
    RfpRatingsProductStar,
  },
  inject: ['isRightToLeftActive'],
  props: {
    headerTitle: {
      type: String,
      required: false,
    },
    labelQualityOfProduct: {
      type: String,
      required: false,
    },
    rateQualityOfProduct: {
      type: String,
      required: false,
    },
    summary: {
      type: String,
      required: false,
    },
    rrids: {
      type: Number,
      required: false,
    },
    helpfulLabels: {
      type: String,
      required: false,
    },
    reportedTexts: {
      type: String,
      required: false,
    },
    reportTexts: {
      type: String,
      required: true,
    },
    updateHelpfulReviewApis: {
      type: String,
      required: false,
    },
    updateNotHelpfulReviewApis: {
      type: String,
      required: false,
    },
    reportReviewApis: {
      type: String,
      required: false,
    },
    isRecommends: {
      type: String,
      required: false,
    },
    helpfulIcon: {
      type: String,
      required: true,
    },
    helpfulIconAlt: {
      type: String,
      required: true,
    },
    nonHelpfulIcon: {
      type: String,
      required: true,
    },
    nonHelpfulIconAlt: {
      type: String,
      required: true,
    },
    recommendListIcons: {
      type: String,
      required: true,
    },
    recommendIconAltTexts: {
      type: String,
      required: true,
    },
    productNames: {
      type: String,
      required: true,
    },
    reviewContents: {
      type: String,
      required: true,
    },
    reviewTitles: {
      type: String,
      required: true,
    },
    facebookCaptions: {
      type: String,
      default: 'Facebook',
    },
    facebookShareEnableds: {
      type: Boolean,
      required: true,
    },
    shareDisplayConfigs: {
      type: String,
      required: true,
    },
    facebookIcons: {
      type: String,
      default: '',
    },
    facebookIconAlts: {
      type: String,
      default: '',
    },
    showHideQualityOfProducts: {
      type: Boolean,
      required: true,
    },
    showHideSubTitles: {
      type: Boolean,
      required: true,
    },
    field: {
      type: Object,
      required: true,
    },
    modalCloseButtonAccessibleLabel: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      deactivateFocusTrap: null,
    };
  },
  computed: {
    showTitle() {
      return this.showHideSubTitles && this.headerTitle;
    },
    popupFields() {
      const fields = [
        {
          isEnabled: this.showHideQualityOfProducts,
          label: this.labelQualityOfProduct,
          rating: parseInt(this.rateQualityOfProduct),
          isStar: true,
        },
        {
          isEnabled: this.field.showHideEffectivenessOfTheProduct,
          label: this.field.effectivenessOfTheProductLabel,
          rating: parseInt(this.field.effectivenessOfTheProduct),
          isStar: true,
        },
        {
          isEnabled: this.field.showHideTextureOfTheProduct,
          label: this.field.textureOfTheProductLabel,
          rating: parseInt(this.field.textureOfTheProduct),
          isStar: true,
        },
        {
          isEnabled: this.field.showHidepricePositionOfTheProduct,
          label: this.field.pricePositionOfTheProductLabel,
          rating: parseInt(this.field.pricePositionOfTheProduct),
          isStar: true,
        },
        {
          isEnabled: this.field.showHideHowDidYouHearAboutTheProduct,
          label: this.field.howDidYouHearAboutTheProductLabel,
          isStar: false,
          value: this.field.howDidYouHearAboutTheProduct,
        },
        {
          isEnabled: this.field.showHideGender,
          label: this.field.genderLabel,
          isStar: false,
          value: this.field.gender,
        },
      ];

      return fields.filter((i) => i.isEnabled && (i.rating || i.value));
    },
  },
  mounted() {
    this.deactivateFocusTrap = trapFocus(this.$refs.popup);
    document.addEventListener('keydown', this.handleCloseOnEsc);
  },
  unmounted() {
    this.handleUnmounted();
  },
  destroyed() {
    this.handleUnmounted();
  },
  methods: {
    handleUnmounted() {
      this.deactivateFocusTrap();
      document.removeEventListener('keydown', this.handleCloseOnEsc);
    },
    handleCloseOnEsc(event) {
      if (event.key === 'Escape') {
        this.closePopup();
      }
    },
    closePopup() {
      this.$parent.activePopup = false;
      const scrollBody = document.getElementsByTagName('body')[0];
      scrollBody?.classList.remove('popup_scroll');
    },
  },
};
</script>
